// src/features/permissions/PermissionsPage.jsx
import { useState, useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Shield, Eye, Edit } from 'lucide-react';
import { useAuth } from '../../context';
import { PERMISSIONS } from '../../constants';
import ViewPermissions from './ViewPermissions';
import PermissionsManager from './PermissionsManager';
import './PermissionsPage.css';

export default function PermissionsPage() {
  const { hasPermission } = useAuth();

  // ✅ Check if user can assign permissions
  const canAssign = hasPermission(PERMISSIONS.ROLES.ASSIGN);

  const [activeTab, setActiveTab] = useState('view');

  // ✅ If user cannot assign, force view tab
  useEffect(() => {
    if (!canAssign && activeTab === 'manage') {
      setActiveTab('view');
    }
  }, [canAssign, activeTab]);

  return (
    <div className="pp-page">
      <div className="pp-shell">
        {/* Header */}
        <div className="pp-header">
          <div className="pp-header-left">
            <div className="pp-header-icon">
              <Shield size={22} color="white" strokeWidth={2.25} />
            </div>
            <div>
              <span className="pp-eyebrow">Access Control</span>
              <h1 className="pp-title">Permissions</h1>
              <p className="pp-subtitle">View or manage permissions assigned to roles</p>
            </div>
          </div>
        </div>

        {/* Tabs - View FIRST, Manage SECOND */}
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="pp-tabs"
        >
          <Tab 
            eventKey="view" 
            title={
              <span className="pp-tab-label">
                <Eye size={14} />
                View
              </span>
            }
          >
            <div className="pp-tab-content">
              <ViewPermissions />
            </div>
          </Tab>

          {/* ✅ Only show Manage tab if user has roles.assign */}
          {canAssign && (
            <Tab 
              eventKey="manage" 
              title={
                <span className="pp-tab-label">
                  <Edit size={14} />
                  Manage
                </span>
              }
            >
              <div className="pp-tab-content">
                <PermissionsManager />
              </div>
            </Tab>
          )}
        </Tabs>
      </div>
    </div>
  );
}